import React, { useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import Employee from "./app/Components/Employee/views/Employee";
import MyEmployeeAccessLandingPage from "./app/Components/Employee/views/MyEmployeeAccess/MyEmployeeAccessLandingPage";
// import Home from "./app/Components/Home/views/Home";
import AdminSettings from "./app/Components/AdminSettings/views/AdminSettings";
import LandingPage from "./app/Components/LandingPage/views/LandingPage";
//Website
import WebsiteHomePage from "./app/Components/Website/pages/LandingPage";
import Contactus from "./app/Components/Website/pages/Contact";
import DownTime from "./app/Components/Website/pages/DownTime";

//End
// import LeaveLandingPage from "./app/Components/Leave/views/LeaveLandingPage";
import MyEmployee from "./app/Components/MyEmployee/views/MyEmployee";
import PrivateRoute, { OwnerPrivateRoute } from "./PrivateRoute";
import RoleAndAccess from "./app/Components/RoleAndAccess/views/RoleAndAccess";
import Onboarding from "./app/Components/Onboarding/views/Onboarding";
import PayroleLandingPage from "./app/Components/Finance/views/Payrole/PayroleLandingPage";
import ReportsLandingPage from "./app/Components/Finance/views/Reports/ReportsLandingPage";
import TaxLandingPage from "./app/Components/Finance/views/TaxDeclaration/TaxLandingPage";
import OnboardingLandingPage from "./app/Components/OnboardingSettings/views/OnboardingLandingPage";
import AdminLandingPage from "./app/Components/MeeplAdmin1/views/AdminLandingPage";


import MeeplAdminLandingPage from "./app/Components/MeeplAdmin/views/MeeplAdminLandingPage";
import MeeplAdminSiginPage from "./app/Components/MeeplAdmin/views/MeeplAdminSiginPage";

import FinanceSettingsLandingPage from "./app/Components/FinanceSettings/views/FinanceSettingsLandingPage";
import AtsDashboard from "./app/Components/ATS/views/Dashboard/AtsDashboard";
import AtsCompanyLandingPage from "./app/Components/ATS/views/ATSCompany/AtsCompanyLandingPage";
import AtsCompanyGroupLandingPage from "./app/Components/ATS/views/ATSGroupCompany/AtsGroupCompanyLandingPage";
import AtsCandidateLandingPage from "./app/Components/ATS/views/ATSCandidate/AtsCandidateLandingPage";
import AtsConsultancyLandingPage from "./app/Components/ATS/views/ATSConsultancy/AtsConsultancyLandingPage";
import AtsJobPostLandingPage from "./app/Components/ATS/views/ATSJobPost/AtsJobPostLandingPage";
import AtsUserLandingPage from "./app/Components/ATS/views/ATSUser/AtsUserLandingPage";
import ForgotPassword from "./app/Components/SignIn/views/ForgotPassword";
import ChangePassword from "./app/Components/SignIn/views/ChangePassword";
import AtsCandidatePortal from "./app/Components/ATS/views/ATSCandidate/AtsCandidatePortal";
import SignIn from "./app/Components/SignIn/views/SignIn";
import ForgotWorkspace from "./app/Components/SignIn/views/Forgotworkspace";
import AtsCareerPortalCandidateForm from "./app/Components/ATS/views/AtsCareerPortal/AtsCareerPortalCandidate";
import CareePortalJob from "./app/Components/ATS/views/AtsCareerPortal/AtsCareerPortalJob";
import CareePortalJobs from "./app/Components/ATS/views/AtsCareerPortal/AtsCareerPortalJobs";
import ATSGenerateInvoice from "./app/Components/ATS/views/ATSInvoice/ATSGenerateInvoice";
import AtsAgreements from "./app/Components/ATS/views/ATSAgreements/ATSAgreements.js";
import AtsSwitchWorkspace from "./app/Components/ATS/views/Dashboard/AtsSwitchWorkSpace";
import AtsReportLandingPage from "./app/Components/ATS/views/AtsReports/AtsReportLandingPage";
import AtsReportDashboardPage from "./app/Components/ATS/views/AtsReports/Dashboard/AtsReportDashboardPage";
import AtsReportRevenuePage from "./app/Components/ATS/views/AtsReports/Revenue/AtsReportRevenuePage";
import AtsCandidateExportLandingPage from "./app/Components/ATS/views/AtsCandidateExport/AtsCandidateExportLandingPage";
import TaskLandingPage from "./app/Components/ATS/views/ATSTask/TaskLandingPage";
import AtsSettings from "./app/Components/ATSSettings/views/AtsSettingsLandingPage";
import RequestDemo from "./app/Components/SignUp/views/RequestDemo";
import AtsCandidateFilters from "./app/Components/ATS/views/ATSCandidate/CandidateFilter/AtsCandidateFilters";
import AISuggestion from "./app/Components/ATS/views/ATSJobPost/Kanban/AISuggestion";
import AtsJobPostForm from "./app/Components/ATS/views/ATSJobPost/AtsJobPostForm";
import FormResponse from "./app/Components/ATSSettings/views/FormBuilder/FormResponse";



//Leave
import DashboardLandingPage from "./app/Components/MyTime/views/DashboardLandingPage";
import TeamLandingPage from "./app/Components/MyTime/views/Team/TeamLandingPage";
import MyTimesheetLandingPage from "./app/Components/MyTime/views/MyTimeSheet/MyTimeSheetLandingPage";


import ConfigureLandingPage from "./app/Components/Configure/views/ConfigureLandingPage";
import Onboardemployee from "./app/Components/ConfigureEmployee/views/ConfigureEmployeeLandingPage";
import PreScreenResponse from "./app/Components/ATSSettings/views/PreScreen/PreScreenResponse";
import PreScreenResponses from "./app/Components/ATS/views/ATSJobPost/PreScreenResponses";
import FeedBackResponse from "./app/Components/ATS/views/ATSJobPost/FeedBackResponse";
import GiveFeedback from "./app/Components/ATSSettings/views/FormBuilder/GiveFeedback";
import MyProfile from "./app/Components/Home/views/MyProfile";
import ViewOffer from "./app/Components/ATS/views/OfferLetter/ViewOffer";
import OfferApproval from "./app/Components/ATS/views/OfferLetter/OfferApproval";
import OfferAccept from "./app/Components/ATS/views/OfferLetter/OfferAccept";
import Dashboard from "./app/Components/Achievement Orchestrator/views/Dashboard/Dashboard";
import { Refresh } from "./app/Components/SignIn/helper/SigninHelper";
import * as ActionTypes from './store/Menu/ActionTypes';
import { useDispatch } from "react-redux";
import { AddMenuHeadingAction } from "./store/Menu/Action";
import FaceAttendanceTracker from "./app/Components/FaceAttendance/FaceAttendanceTracker";
import NewPaySlip from "./app/Components/Finance/views/Employee/NewPaySlip";
import EmployeePayrollLandingPage from "./app/Components/Finance/views/Reports/EmployeePayrollLandingPage";
import EmployeeBulkUploadLandingPage from "./app/Components/MyEmployee/views/BulkUpload/EmployeeBulkUploadLandingPage";
import TeamBalanceLandingPage from "./app/Components/MyTime/views/Team/TeamBalanceLandingPage";
import BioMetricUpload from "./app/Components/MyTime/views/BulkUpload/BioMetricUpload";
import TaxAdminPage from "./app/Components/Finance/views/TaxDeclaration/TaxAdminPage";

import SubscribeSettingsLandingPage from "./app/Components/AdminSettings/views/Subscribe/SubscribeSettingsLandingPage ";
import Holidays from "./app/Components/Leave/views/Holidays/Holidays";
import PostAdjustmentLandingPage from "./app/Components/Finance/views/PostAdjustment/PostAdjustmentLandingPage";
import VisitorManagement from "./app/Components/VisitorsManagement/views/VisitorsManagement";
import VisitorsDashboard from './app/Components/VisitorsManagement/views/Dashboard/VisitorsDashboard'
import VisitorsRecord from "./app/Components/VisitorsManagement/views/VisitorsRecord";
import VisitorsSetting from "./app/Components/VisitorSettings/views/VisitorsSettingsLandingPage";
import RegionLandingpage from "./app/Components/VisitorsManagement/views/Region/RegionLandingPage";
import PayrollDashboard from "./app/Components/Finance/views/Dashboard/PayrollDashboard";
import EmployeeReportLandingPage from "./app/Components/Finance/views/EmployeeReport/EmployeeReportLandingPage";
import TeamExpenseLandingPage from "./app/Components/ExpenseManagement/views/TeamExpense/TeamExpenseLandingPage";
import MyExpense from "./app/Components/ExpenseManagement/views/MyExpense/MyExpense";
import ExpenseSettings from "./app/Components/ExpenseSettings/views/ExpenseSettingLandingPage";
import PayrollManagementLandingPage from "./app/Components/Finance/views/PayrollManagement/PayrollMgLandingPage";
import PayconfigLandingPage from "./app/Components/Finance/views/Payconfig/PayconfigLandingPage";
import PerformanceSetting from "./app/Components/PerformanceSettings/views/PerformanceSettingLandingPage";
import MyEcms from "./app/Components/ECMSystem/views/MyEcms/MyEcms";
import PayEcmsLandingPage from "./app/Components/Finance/views/PayECMS/PayEcmsLandingPage";
import ManagerViewEcmsLandingPage from "./app/Components/ECMSystem/views/ManagerEcms/ManagerViewEcmsPage";
import EmployeeClearanceGrid from "./app/Components/ECMSystem/views/EmployeeClearance/EmployeeClearance";
import EcmsLandingPage from "./app/Components/ECMSystem/views/LandingPage/EcmsLandingPage";
import AdminViewEcmsLandingPage from "./app/Components/ECMSystem/views/AdminEcms/AdminViewLandingPage";
import TeamTimeExecutivePage from "./app/Components/MyTime/views/TeamExecutive/TeamTimeExecutivePage";
import TeamTimePublic from "./app/Components/MyTime/views/PublicTeamTime/TeamTimePublic";
import EmployeeTokenConfigGrid from "./app/Components/CanteenManagement/views/TokenConfig";
import CanteenRegion from "./app/Components/CanteenManagement/views/CanteenRegion";
import CanteenPortalPage from "./app/Components/CanteenManagement/views/CanteenPortal";
import CanteenSetting from "./app/Components/CanteenSetting/views/CanteenSettingPage";
import TokenDownloadPage from "./app/Components/CanteenManagement/views/TokenQRDownload";
import PrivacyPolicyApp from "./app/Components/Website/views/PrivacyPolicy/PrivacyPolicyApp";
import PageNotFound from "./app/Components/Base/views/PageNotFound";
import AtsInvoiceTabs from "./app/Components/ATS/views/ATSInvoice/AtsInvoiceTabs";
// import ComingSoon from "./app/Components/Base/views/ComingSoon";
import AppLayout from "./app/Components/Base/views/AppLayout";
import HiringRequestLandingPage from "./app/Components/ATS/views/ATSHiringRequest/HiringRequestLandingPage";
import DeleteAccountStepPage from "./app/Components/Website/views/PrivacyPolicy/DeleteAccountStep";
import PreRegistrationLandingPage from "./app/Components/VisitorsManagement/views/PreRegistration/PreRegistrationLandingPage";
import CommonPortal from "./app/Components/FaceAttendance/CommonPortal";
import GuestPassDownload from "./app/Components/VisitorsManagement/views/PreRegistration/GuestPassDownload";
import FaceAttendanceTrackerNew from "./app/Components/FaceAttendance/FaceAttendanceTrackerNew";
import FaceAttendanceTrackerNewTest from "./app/Components/FaceAttendance/FaceAttendanceTrackerNewTest";
import FaceAttendanceTrackerEnhanced from "./app/Components/FaceAttendance/FaceAttendanceTrackerEnhanced";


function Routes({ region }) {
  const dispatch = useDispatch();
  function validateRegion(routeRegion) {
    return routeRegion === region;
  }
  useEffect(() => {
    const handlePageLoad = () => {
      const menu = sessionStorage.getItem("selectedMenu");
      dispatch(AddMenuHeadingAction({ heading: menu }));
      dispatch({ type: ActionTypes.OPEN_MENU });
      dispatch({ type: ActionTypes.FIXED_MENU_OPEN });
      Refresh(dispatch);
    };
    if (document.readyState === "complete") {
      handlePageLoad();
    } else {
      window.addEventListener("load", handlePageLoad);
    }
    return () => {
      window.removeEventListener("load", handlePageLoad);
    };
  }, [dispatch]);
  
  const privatePaths = [
    "/home", "/employee", "/Onboardemployee", "/myemployee", "/onboarding",
    "/authorization-management", "/myemployee-assets-management",
    "/lms/manage-dashboard", "/lms/manage-timesheet", "/lms/manage-team", 
    "/lms/team-balance", "/time-bulk-upload", "/holidays", "/lms/team-time",
     "/payroll", "/finance-report", "/tax-declaration",
    "/team-tax-declaration", "/employee-report", "/team-tax-adminview",
    "/payrollconfig-employee", "/payroll-wage-entry", "/myemployee-reports",
    "/payroll-management", "/payroll-payecms", "/payslip", "/employee-bulk-upload",
    "/payroll-dashboard", "/settings", "/role-access", "/onboarding-settings",
    "/finance-settings", "/subscribe", "/admin",
    "/ats/dashboard", "/ats/manage-job", "/ats/add-job/", "/ats/manage-company",
    "/ats/manage-group-company", "/ats/manage-candidate", "/ats/filter-candidate",
    "/ats/manage-user", "/ats/manage-consultancy", "/ats/invoice",
    "/ats/manage-reports/", "/ats/reports/", "/ats/candidate-export/", "/ats/revenue/",
    "/ats/tasks/", "/ats/ats-settings/", "/ats/suggest-candidate/:job_id",
    "/performance-management", "/settings/performance-management",
    "/visitors-record", "/visitors-dashboard",
    "/visitors-management/settings", "/visitors-management-region", "/visitors-pre-registration",
    "/canteen-management-tokenconfig", "/canteen-management-region",
    "/canteen-management/settings", "/expense-management/my-expenses",
    "/expense-management/team-expenses", "/expense-management/settings",
    "/exit-management", "/exit-management/my-ecms", "/exit-management/admin-view",
    "/exit-management/manager-view", "/ats/hiring-requests", "/ats/agreements"
  ];
  return (
    <Switch>
        {/* Authentication */}
        <Route exact path="/forgotWorkspace" component={ForgotWorkspace} />
        <Route exact path="/forgotPassword" component={ForgotPassword} />
        <Route exact path="/changePassword/:token" component={ChangePassword} />
        <Route exact path="/signin/:info" component={SignIn} />
        {/* Website */}
        <Route exact path="/ContactUs" component={Contactus} />
        <Route exact path="/DownTime" component={DownTime} />

        {/* Mobile App */}
        <Route exact path="/app-privacy-policy" component={PrivacyPolicyApp} />
        <Route exact path="/delete-account" component={DeleteAccountStepPage} />

        <Route exact path="/:region/signup" component={LandingPage} />
        <Route exact path="/:region/requestDemo" component={RequestDemo} />
        <Route exact path="/" component={WebsiteHomePage} />

        {/* workspace-initial-setup */}
        <OwnerPrivateRoute exact path="/configure-setting" component={ConfigureLandingPage} /> {/*Unauthorized Base*/}
        {/* Employee */}
        <PrivateRoute exact path="/employee/Onboardemployee/" component={Onboardemployee} /> {/*Unauthorized Base*/}
        
        {/* Face */}
        <PrivateRoute exact path="/face-attendance-tracker/:user_id" component={FaceAttendanceTracker} />  {/* no in use: review and delete */}
        <PrivateRoute exact path="/face-attendance-tracker-new/:user_id" component={FaceAttendanceTrackerNew} />
        <PrivateRoute exact path="/face-attendance-tracker-new-test/:user_id" component={FaceAttendanceTrackerNewTest} /> {/* only for testing */}
        <PrivateRoute exact path="/face-attendance-tracker-new-test1/:user_id" component={FaceAttendanceTrackerEnhanced} /> {/* only for testing */}

        {/* Employee Attendance + Visitor Entry Common Portal */}
        <PrivateRoute exact path="/common-portal" component={CommonPortal} />
        <PrivateRoute exact path="/visitors-management-common-portal" component={VisitorManagement} />
        {/* Admin */}
        <PrivateRoute exact path="/meepl-admin" component={MeeplAdminLandingPage} /> {/*Unauthorized Base*/}

        {/* ATS */}
        <PrivateRoute exact path="/ats/switchworkspace/" component={AtsSwitchWorkspace} /> {/*Unauthorized Base*/}


    <Route path={privatePaths}>
      <AppLayout>
        <Switch>
        {/* Core HR */}
        {/* <PrivateRoute exact path="/home" component={Home} /> */}
        <PrivateRoute exact path="/home" component={MyProfile} />  {/*Base*/}
        {/* <PrivateRoute exact path="/leave" component={LeaveLandingPage} /> */}
        {/* <PrivateRoute exact path="/leave" component={ComingSoon} /> */}
        <PrivateRoute exact path="/employee" component={Employee} /> {/*Base*/}
        <PrivateRoute exact path="/Onboardemployee" component={MyEmployee} /> {/*Base*/}
        <PrivateRoute exact path="/myemployee" component={MyEmployee} /> {/*Base*/}
        <PrivateRoute exact path="/onboarding" component={Onboarding} /> {/*Base*/}
        <PrivateRoute exact path="/authorization-management" component={MyEmployeeAccessLandingPage} /> {/*Base*/}
        <PrivateRoute exact path="/myemployee-assets-management" component={EmployeeClearanceGrid} /> {/*Base*/}
        
        {/* Leave */}
        <PrivateRoute exact path="/lms/manage-dashboard" component={DashboardLandingPage} /> {/*Base*/}
        <PrivateRoute exact path="/lms/manage-timesheet" component={MyTimesheetLandingPage} /> {/*Base*/}
        <PrivateRoute exact path="/lms/manage-team" component={TeamLandingPage} /> {/*Base*/}
        <PrivateRoute exact path="/lms/team-balance" component={TeamBalanceLandingPage} /> {/*Nooo base -- not used route*/}
        <PrivateRoute exact path="/time-bulk-upload" component={BioMetricUpload} /> {/*Base*/}
        <PrivateRoute exact path="/holidays" component={Holidays} /> {/*Base*/}
        <PrivateRoute exact path="/lms/team-time" component={TeamTimeExecutivePage} /> {/*Base*/}

        {/* Finance */}
        <PrivateRoute exact path="/payroll" component={PayroleLandingPage} /> {/*Base*/}
        <PrivateRoute exact path="/finance-report" component={ReportsLandingPage} /> {/*Base*/}
        <PrivateRoute exact path="/tax-declaration" component={TaxLandingPage} /> {/*Base*/}
        <PrivateRoute exact path="/team-tax-declaration" component={TaxAdminPage} /> {/*Base*/}
        <PrivateRoute exact path="/employee-report" component={EmployeeReportLandingPage} /> {/*Base*/}
        <PrivateRoute exact path="/team-tax-adminview" component={TaxLandingPage} /> {/*Base*/}
        <PrivateRoute exact path="/payrollconfig-employee" component={PayconfigLandingPage} /> {/*Base*/}
        <PrivateRoute exact path="/payroll-wage-entry" component={PostAdjustmentLandingPage} /> {/*Base*/}
        <PrivateRoute exact path="/myemployee-reports" component={EmployeePayrollLandingPage} /> {/*Base*/}
        <PrivateRoute exact path="/payroll-management" component={PayrollManagementLandingPage} /> {/*Base*/}
        <PrivateRoute exact path="/payroll-payecms" component={PayEcmsLandingPage} /> {/*Base*/}

        {/* <PrivateRoute exact path="/employee-time" component={EmployeeTimeLandingPage} /> */}  
        <PrivateRoute exact path="/payslip" component={NewPaySlip} /> {/*Nooo base -- not used route*/}
        <PrivateRoute exact path="/employee-bulk-upload" component={EmployeeBulkUploadLandingPage} /> {/*Base*/}
        <PrivateRoute exact path="/payroll-dashboard" component={PayrollDashboard} /> {/*Base*/}
        {/* Settings */}
        <PrivateRoute exact path="/settings" component={AdminSettings} /> {/*Base*/}
        <PrivateRoute exact path="/role-access" component={RoleAndAccess} /> {/*Base*/}
        <PrivateRoute exact path="/onboarding-settings" component={OnboardingLandingPage} /> {/*Base*/}
        <PrivateRoute exact path="/finance-settings" component={FinanceSettingsLandingPage} /> {/*Base*/}
        <PrivateRoute exact path="/subscribe" component={SubscribeSettingsLandingPage} /> {/*Base*/}
        {/* Admin */}
        <PrivateRoute exact path="/admin" component={AdminLandingPage} /> {/*Base*/}
        {/* ATS */}
        <PrivateRoute exact path="/ats/dashboard" component={AtsDashboard} /> {/*Base*/}
        <PrivateRoute exact path="/ats/manage-job" component={AtsJobPostLandingPage} /> {/*Base*/}
        <PrivateRoute exact path="/ats/add-job/" component={AtsJobPostForm} /> {/*Base*/}
        <PrivateRoute exact path="/ats/manage-company" component={AtsCompanyLandingPage} /> {/*Base*/}
        <PrivateRoute exact path="/ats/manage-group-company" component={AtsCompanyGroupLandingPage} /> {/*Base*/}
        <PrivateRoute exact path="/ats/manage-candidate" component={AtsCandidateLandingPage} /> {/*Base*/}
        <PrivateRoute exact path="/ats/filter-candidate" component={AtsCandidateFilters} /> {/*Base*/}
        <PrivateRoute exact path="/ats/manage-user" component={AtsUserLandingPage} /> {/*Base*/}
        <PrivateRoute exact path="/ats/manage-consultancy" component={AtsConsultancyLandingPage} /> {/*Base*/}
        <PrivateRoute exact path="/ats/invoice" component={AtsInvoiceTabs} /> {/*Base*/}
        <PrivateRoute exact path="/ats/agreements" component={AtsAgreements} />{/*Base*/}
        
        <PrivateRoute exact path="/ats/manage-reports/" component={AtsReportDashboardPage} /> {/*Base*/}
        <PrivateRoute exact path="/ats/reports/" component={AtsReportLandingPage} /> {/*Base*/}
        <PrivateRoute exact path="/ats/candidate-export/" component={AtsCandidateExportLandingPage} /> {/*Base*/}
        <PrivateRoute exact path="/ats/revenue/" component={AtsReportRevenuePage} /> {/*Base*/}
        <PrivateRoute exact path="/ats/tasks/" component={TaskLandingPage} /> {/*Base*/}
        <PrivateRoute exact path="/ats/hiring-requests" component={HiringRequestLandingPage} /> {/*Base*/}
        
        <PrivateRoute exact path="/ats/ats-settings/" component={AtsSettings} /> {/*Base*/}
        <PrivateRoute exact path="/ats/suggest-candidate/:job_id" component={AISuggestion} /> {/*Base*/}
        
        <PrivateRoute path="/performance-management" component={Dashboard} /> {/*Base*/}
        <PrivateRoute exact path="/settings/performance-management" component={PerformanceSetting} /> {/*Base*/}
        
        {/* Visitors Management */} 
        <PrivateRoute exact path="/visitors-record" component={VisitorsRecord} /> {/*Base*/}
        <PrivateRoute exact path="/visitors-dashboard" component={VisitorsDashboard} /> {/*Base*/}
        <PrivateRoute exact path="/visitors-management/settings" component={VisitorsSetting} /> {/*Base*/}
        <PrivateRoute exact path="/visitors-management-region" component={RegionLandingpage} /> {/*Base*/}
        <PrivateRoute exact path="/visitors-pre-registration" component={PreRegistrationLandingPage} /> {/*Base*/}

        {/* Canteen Management */}
        <PrivateRoute exact path="/canteen-management-tokenconfig" component={EmployeeTokenConfigGrid} /> {/*Base*/}
        <PrivateRoute exact path="/canteen-management-region" component={CanteenRegion} /> {/*Base*/}
        <PrivateRoute exact path="/canteen-management/settings" component={CanteenSetting} /> {/*Base*/}

        {/* Expene Management */}
        <PrivateRoute exact path="/expense-management/my-expenses" component={MyExpense} /> {/*Base*/}
        <PrivateRoute exact path="/expense-management/team-expenses" component={TeamExpenseLandingPage} /> {/*Base*/}
        <PrivateRoute exact path="/expense-management/settings" component={ExpenseSettings} /> {/*Base*/}

        {/* ECMSystem */}
        <PrivateRoute exact path="/exit-management" component={EcmsLandingPage} /> {/*Base*/}
        <PrivateRoute exact path="/exit-management/my-ecms" component={MyEcms} /> {/*Base*/}
        <PrivateRoute exact path="/exit-management/admin-view" component={AdminViewEcmsLandingPage} /> {/*Base*/}
        <PrivateRoute exact path="/exit-management/manager-view" component={ManagerViewEcmsLandingPage} /> {/*Base*/}
        
        {/* Page Not Found for invalid Private Routes inside AppLayout */}
        <Route component={PageNotFound} />
        </Switch>
      </AppLayout>
    </Route>
        {/* Team Time */}
        <Route exact path="/meepl-public/team-time/:domain/:userToken" component={TeamTimePublic} />
        {/* Admin */}
        <Route exact path="/admin-signin" component={MeeplAdminSiginPage} />
        {/* Visitors Management */} 
        <Route exact path="/visitors-management-portal/:userId/:domain/:company/:region_fk/:whatsflow" component={VisitorManagement} />
        <Route exact path="/vm-guestpass-download-portal" component={GuestPassDownload} />

        {/* Canteen Management */}
        <Route exact path="/canteen-management-portal/:domain/:userToken" component={CanteenPortalPage} />
        <Route exact path="/canteen-management-download-portal/:region/:token_id" component={TokenDownloadPage} />
        {/* ATS */}
        <Route exact path="/ats/add-candidate/:guid" component={AtsCandidatePortal} />
        <Route exact path="/ats/career-portal/candidate/:domain" component={AtsCareerPortalCandidateForm} />
        <Route exact path="/ats/career-portal-job/:jobid/:domain" component={CareePortalJob} />
        <Route exact path="/ats/career-portal-jobs/:jobid/:domain" component={CareePortalJobs} />
        <Route exact path="/ats/feedback-response/:guid" component={FormResponse} />
        <Route exact path="/ats/give-feedback/" component={GiveFeedback} />
        <Route exact path="/ats/feedback-responses/:guid" component={FeedBackResponse} />
        <Route exact path="/ats/prescreen-response/:guid" component={PreScreenResponse} />
        <Route exact path="/ats/prescreen-responses/:guid" component={PreScreenResponses} />
        <Route exact path="/ats/view-offer/:guid" component={ViewOffer} />
        <Route exact path="/ats/offer-approval/:guid" component={OfferApproval} />
        <Route exact path="/ats/offer-accept/:guid" component={OfferAccept} />

        <Route exact path="/:region" render={({ match }) => validateRegion(match.params.region) ? (<WebsiteHomePage />) : <PageNotFound />} />
        
        <Route exact path="/page-not-found" component={PageNotFound } />
        {/* page not found */}
        <Route component={PageNotFound } />
    </Switch>
  );
}

export default Routes;
